module.exports = __webpack_public_path__ + "static/media/mausam - thunderstorm.3c8efb6b.png";